
import FeaturedCard from '~/components/public/featured/featured-card.vue'

export default {
  components: {
    FeaturedCard,
  },
  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    cta: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    firstPublishedAt: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },

    // Optional
    orientation: {
      type: String,
      default: 'vertical',
      validator: (value) =>
        ['vertical', 'horizontal'].includes(value.toLowerCase()),
    },
    tags: {
      type: Array,
      default: () => [],
    },
    readingTimeInMinutes: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    hasTags() {
      return this.tags.length > 0
    },

    permaLink() {
      return `/articles/${this.slug}`
    },

    metaInformation() {
      return [
        {
          icon: 'calendar',
          label: this.$gettext('Date published'),
          value: this.$formatAsDate(this.firstPublishedAt),
        },
        {
          icon: 'reading-time',
          label: this.$gettext('Reading time'),
          value: this.readingTimeInMinutes + ' min.',
        },
      ]
    },
  },
}
